var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authentication-component"},[_c('div',{staticClass:"authentication-wrapper"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('LineLoader',{attrs:{"show":true,"additionalClass":"bottom"}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-wrapper"},[_c('h1',[_vm._v("Logging Out")])])
}]

export { render, staticRenderFns }